import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./ReaderPage.css";

const markdownContent = `
# The businessman and the fisherman

A fisherman lay on a beach, enjoying the sun and the gentle surf, his line cast into the water. A businessman, stressed from work, approached him.

“You won’t catch many fish that way,” the businessman said. “You should work harder.”

“And what will my reward be?” the fisherman asked.

“With effort, you can buy a boat, catch more fish, build a fleet, and become rich!” the businessman explained.

“And then what would I get?” the fisherman asked again.

“Eventually, you’ll be so wealthy you can relax on a beach, free from worries!” the businessman exclaimed.

The fisherman smiled. “And what do you think I’m doing right now?”
`;

const ReaderPage = () => {
    useEffect(() => {
        // Find the article content div
        const articleElement = document.querySelector("#article-content");
        if (!articleElement) {
            console.error("🚨 #article-content div not found!");
            return;
        }

        console.log("✅ Found #article-content, inserting widget script...");

        // Remove any existing script to prevent duplicate initialization
        const existingScript = document.querySelector('script[src*="article_widget.js"]');
        if (existingScript) {
            existingScript.remove();
        }

        // Create and insert the widget script inside the article div
        const script = document.createElement("script");
        script.src = "https://wsl.nategrieb.com/article_widget.js"; // ✅ Load from the frontend    
        script.async = true;
        articleElement.appendChild(script);

    }, []);

    return (
        <div className="knowledge-article">
            {/* ✅ The widget will be placed inside this div */}
            <div id="article-content">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        code({ node, inline, className, children, ...props }) {
                            return null; // ✅ Skip code blocks so they are NOT read aloud
                        }
                    }}
                >
                    {markdownContent}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export default ReaderPage;